'use client';

import { t } from 'mobx-state-tree';

import type { UserInfo } from '@/context/AuthContext';

/** User info model for global state */
const UserInfoModel = t
  .model('UserInfo', {
    userName: t.maybeNull(t.string),
    email: t.maybeNull(t.string),
    imageUrl: t.maybeNull(t.string),
    fullName: t.maybeNull(t.string),
  });

/** Current user model with Firebase UID */
export const CurrentUserStoreModel = t
  .model('CurrentUser', {
    uid: t.maybeNull(t.string),
    userInfo: t.maybeNull(UserInfoModel),
  })
  .views((self) => ({
    get userInitials() {
      if (!self.userInfo) return '';
      const fullName = self.userInfo.fullName ?? '';
      if (fullName) {
        const nameParts = fullName.split(' ');
        return nameParts.length >= 2 ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}` : fullName.substring(0, 2);
      }
      return self.userInfo.userName?.substring(0, 2) ?? '';
    },
    /** Check if a given ownerId belongs to the current user */
    isOwner: (ownerId: string) => self.uid === ownerId,
  }))
  .actions((self) => ({
    setCurrentUser(uid: string | null, userInfo: UserInfo | null) {
      self.uid = uid;
      self.userInfo = userInfo;
    },
  }));
